// extracted by mini-css-extract-plugin
export var alt = "BookNowBanner-module--alt--5eee8";
export var banner = "BookNowBanner-module--banner--6f4e4";
export var desktopOnly = "BookNowBanner-module--desktopOnly--7d962";
export var main = "BookNowBanner-module--main--d86c1";
export var mobileOnly = "BookNowBanner-module--mobileOnly--e84df";
export var textLeft = "BookNowBanner-module--textLeft--14d0d";
export var visuallyHidden = "BookNowBanner-module--visuallyHidden--80b4c";